import { render, staticRenderFns } from "./AllAdminViewAssignTagOnContactSDData.vue?vue&type=template&id=40b01f44&scoped=true"
import script from "./AllAdminViewAssignTagOnContactSDData.vue?vue&type=script&lang=js"
export * from "./AllAdminViewAssignTagOnContactSDData.vue?vue&type=script&lang=js"
import style0 from "./AllAdminViewAssignTagOnContactSDData.vue?vue&type=style&index=0&id=40b01f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b01f44",
  null
  
)

export default component.exports